import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { AddFlowTT } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const AddFlowPage: FC = () => {
  const { accessToAddTiktokflow } = usePermissionGuard();
  return (
    <Guard hasAccess={accessToAddTiktokflow}>
      <CabinetTitlePage
        title={'Flows'}
        goBack={'/cabinet/tiktok/flows'}
      />
      <AddFlowTT />
    </Guard>
  );
};

export default AddFlowPage;
